(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2870],{

/***/ 20640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(11742);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 75273:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pending",
      function () {
        return __webpack_require__(99445);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$$default": function() { return /* binding */ $$default; },
/* harmony export */   "Link": function() { return /* binding */ Link; },
/* harmony export */   "default": function() { return /* binding */ $$default; },
/* harmony export */   "getSessionIdToken": function() { return /* binding */ getSessionIdToken; },
/* harmony export */   "heading": function() { return /* binding */ heading; },
/* harmony export */   "img": function() { return /* binding */ img; },
/* harmony export */   "imgAnimated": function() { return /* binding */ imgAnimated; },
/* harmony export */   "make": function() { return /* binding */ make; },
/* harmony export */   "rootContainer": function() { return /* binding */ rootContainer; },
/* harmony export */   "submitBtnStyle": function() { return /* binding */ submitBtnStyle; },
/* harmony export */   "text": function() { return /* binding */ text; }
/* harmony export */ });
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20859);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_library_Button_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59037);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43437);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72491);
/* harmony import */ var _components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config_Localization_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98765);
/* harmony import */ var _api_helpers_ts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60693);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
/* harmony import */ var _components_library_ResponsiveClipboard_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9229);
__webpack_require__(14473);
// Generated by ReScript, PLEASE EDIT WITH CARE












function getSessionIdToken(prim) {
    return _api_helpers_ts__WEBPACK_IMPORTED_MODULE_6__/* .getSessionIdToken */ .qB(prim);
}
var rootContainer = "text-center my-20 w-10/12 md:w-1/2 mx-auto self-center animate__animated animate__fadeIn animate__slow";
var heading = "text-2xl md:text-4xl font-bold";
var img = "mx-auto my-4";
var imgAnimated = img + " animate__animated animate__jackInTheBox animate__slow";
var text = "text-lg mt-8 mx-auto text-gray-600";
function Pending(props) {
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        window.scrollTo(0, 0);
        _api_helpers_ts__WEBPACK_IMPORTED_MODULE_6__/* .getSessionIdToken */ .qB({
            updateConfig: true,
            resetToken: true
        });
    }, []);
    var router = next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter();
    var orderNumberOpt = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_9__/* .get */ .U2(router.query, "order");
    var fraudOpt = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_9__/* .get */ .U2(router.query, "paymentassessment");
    var riskOpt = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_9__/* .get */ .U2(router.query, "riskassessment");
    var nowrap = function nowrap(text) {
        return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(text.replace(/ /g, "\xa0"));
    };
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
        children: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_10__/* .isSome */ .pC(riskOpt) ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                    src: "/images/error_icon.svg",
                    alt: "Order failed",
                    width: 60,
                    height: 60,
                    className: img
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("h1", {
                    children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("We couldn't complete your order"),
                    className: heading
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs("p", {
                    children: [
                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("If you need any help, please "),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("a", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("contact us"),
                            className: "text-blue-500 underline hover:no-underline",
                            href: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_10__/* .getWithDefault */ .tj(_config_Localization_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .getLocalizedString */ .Z("riskLink"), "/contact/"),
                            target: "_blank"
                        }),
                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(".")
                    ],
                    className: text
                })
            ]
        }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("h1", {
                    children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Oh no!"),
                    className: heading
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                    src: "/images/failed.png",
                    alt: "Order failed",
                    width: 192,
                    height: 198,
                    className: imgAnimated
                }),
                _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_10__/* .isSome */ .pC(fraudOpt) ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("div", {
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs("p", {
                        children: [
                            _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("We were not able to process your order as we could not validate your billing details. Please contact our Customer Care team at "),
                            _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_10__/* .mapWithDefault */ .k7(_config_Localization_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .getLocalizedString */ .Z("supportEmail"), null, _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s),
                            _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(" or "),
                            _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_10__/* .mapWithDefault */ .k7(_config_Localization_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .getLocalizedString */ .Z("phoneNumberWithoutCountryCode"), null, nowrap),
                            _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(" (or +61 2 9093 2777 if you're overseas), we're here to help 24/7.")
                        ],
                        className: text
                    })
                }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("p", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Something went wrong and we could not complete your request."),
                            className: text
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("p", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Our team has been notified and will resolve the issue as soon as we can."),
                            className: text
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs("p", {
                            children: [
                                _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Should you need any urgent assistance or more information, please contact us at "),
                                _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_10__/* .mapWithDefault */ .k7(_config_Localization_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .getLocalizedString */ .Z("supportEmail"), null, _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s),
                                _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(" or "),
                                _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_10__/* .mapWithDefault */ .k7(_config_Localization_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .getLocalizedString */ .Z("phoneNumber"), null, nowrap)
                            ],
                            className: text
                        })
                    ]
                }),
                _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_10__/* .mapWithDefault */ .k7(orderNumberOpt, null, function(orderNumber) {
                    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx(_components_library_ResponsiveClipboard_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .make */ .S, {
                        orderNumber: orderNumber
                    });
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx("button", {
                    children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Go back"),
                    className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .make */ .S([
                        "my-6 w-40 py-4 mx-auto",
                        _components_library_Button_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .primaryStyle */ .vP
                    ]),
                    title: "Go back",
                    onClick: function onClick(e) {
                        e.preventDefault();
                        router.back();
                    }
                })
            ]
        }),
        className: rootContainer
    });
}
var Link;
var submitBtnStyle = "mx-auto mt-6 w-56 h-12";
var make = Pending;
var $$default = Pending;
 /* Util Not a pure module */ 


/***/ }),

/***/ 9229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20859);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92592);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25400);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5__);
// Generated by ReScript, PLEASE EDIT WITH CARE









var button = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_6__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100.0)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2("(min-width: 480px)", {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(20.0)),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    }
});
var copyImg = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_6__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(35))),
    tl: /* [] */ 0
});
var Styles = {
    button: button,
    copyImg: copyImg
};
function ResponsiveClipboard(props) {
    var orderNumber = props.orderNumber;
    var match = react__WEBPACK_IMPORTED_MODULE_2__.useState(function() {
        return false;
    });
    var setIsCopied = match[1];
    var isCopied = match[0];
    var id = {
        contents: setTimeout(function(param) {}, 0)
    };
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        if (isCopied) {
            id.contents = setTimeout(function(param) {
                _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_6__._1(setIsCopied, function(param) {
                    return false;
                });
            }, 1500);
        }
    }, [
        isCopied
    ]);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
        children: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_7__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5___default()), {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs("button", {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs("div", {
                        children: [
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("p", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Your order number"),
                                className: "text-xs text-gray-500"
                            }),
                            isCopied ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("p", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Order copied"),
                                className: "text-xs"
                            }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("p", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(orderNumber),
                                className: "text-xs"
                            })
                        ]
                    }),
                    isCopied ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                        src: "/images/success.svg",
                        alt: "copy",
                        width: 35,
                        height: 35,
                        className: "w-8 h-8 p-1"
                    }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                        src: "/images/copy_button.svg",
                        alt: "copy",
                        width: 24,
                        height: 24,
                        className: copyImg
                    })
                ],
                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .make */ .S([
                    "mx-auto flex items-center justify-between border shadow-md px-2 py-1 rounded-md box-shadow my-2 cursor-pointer text-left outline-none hover:bg-white-smoke",
                    button
                ]),
                onClick: function onClick(param) {
                    _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_6__._1(setIsCopied, function(param) {
                        return true;
                    });
                }
            }),
            text: orderNumber
        }))
    });
}
var make = ResponsiveClipboard;
 /* button Not a pure module */ 


/***/ }),

/***/ 98765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getLocalizedString; }
/* harmony export */ });
/* unused harmony exports MapString, au, us, uk, nz */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93995);
// Generated by ReScript, PLEASE EDIT WITH CARE


var au = _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .fromArray */ .nI([
    [
        "region",
        "AU"
    ],
    [
        "companyName",
        "Prezzee Pty Ltd"
    ],
    [
        "registration",
        "ABN 16602963422"
    ],
    [
        "supportEmail",
        "help@prezzee.com"
    ],
    [
        "corporateEmail",
        "corporate@prezzee.com.au"
    ],
    [
        "phoneNumber",
        "+61 2 9093 2777"
    ],
    [
        "phoneNumberWithoutCountryCode",
        "1800 940 868"
    ],
    [
        "address",
        "Level 3, 9 Castlereagh Street, Sydney, NSW 2000"
    ],
    [
        "personalise",
        "personalise"
    ],
    [
        "Personalise",
        "Personalise"
    ],
    [
        "personalised",
        "personalised"
    ],
    [
        "incentivise",
        "incentivise"
    ],
    [
        "organisations",
        "organisations"
    ],
    [
        "damn",
        "damn"
    ],
    [
        "energised",
        "energised"
    ],
    [
        "customised",
        "customised"
    ],
    [
        "catalogue",
        "catalogue"
    ],
    [
        "apologise",
        "apologise"
    ],
    [
        "riskLink",
        "https://help.prezzee.com.au/hc/en-us/requests/new?ticket_form_id=505267"
    ]
]);
var us = _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .fromArray */ .nI([
    [
        "region",
        "US"
    ],
    [
        "companyName",
        "Prezzee Inc"
    ],
    [
        "registration",
        ""
    ],
    [
        "supportEmail",
        "help@prezzee.com"
    ],
    [
        "corporateEmail",
        "corporate@prezzee.com"
    ],
    [
        "phoneNumber",
        "+1 (833) 300-0982"
    ],
    [
        "phoneNumberWithoutCountryCode",
        "(833) 300-0982"
    ],
    [
        "address",
        "1411 Broadway, New York, NY 10018"
    ],
    [
        "personalise",
        "personalize"
    ],
    [
        "Personalise",
        "Personalize"
    ],
    [
        "personalised",
        "personalized"
    ],
    [
        "incentivise",
        "incentivize"
    ],
    [
        "organisations",
        "organizations"
    ],
    [
        "damn",
        ""
    ],
    [
        "energised",
        "energized"
    ],
    [
        "customised",
        "customized"
    ],
    [
        "catalogue",
        "catalog"
    ],
    [
        "apologise",
        "apologize"
    ],
    [
        "riskLink",
        "https://prezzeeus.zendesk.com/hc/en-us/requests/new?ticket_form_id=505267"
    ]
]);
var uk = _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .fromArray */ .nI([
    [
        "region",
        "UK"
    ],
    [
        "companyName",
        "Prezzee UK"
    ],
    [
        "registration",
        "CRN 12851966"
    ],
    [
        "supportEmail",
        "help@prezzee.com"
    ],
    [
        "corporateEmail",
        "corporate@prezzee.com"
    ],
    [
        "phoneNumber",
        "+44 808 164 9223"
    ],
    [
        "phoneNumberWithoutCountryCode",
        "0808 164 9223"
    ],
    [
        "address",
        "49 Greek Street London, W1D 4EG. UK"
    ],
    [
        "personalise",
        "personalise"
    ],
    [
        "Personalise",
        "Personalise"
    ],
    [
        "personalised",
        "personalised"
    ],
    [
        "incentivise",
        "incentivise"
    ],
    [
        "organisations",
        "organisations"
    ],
    [
        "damn",
        "damn"
    ],
    [
        "energised",
        "energised"
    ],
    [
        "catalogue",
        "catalogue"
    ],
    [
        "apologise",
        "apologise"
    ],
    [
        "riskLink",
        "https://prezzeeuk.zendesk.com/hc/en-us/requests/new?ticket_form_id=505267"
    ]
]);
var nz = _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .fromArray */ .nI([
    [
        "region",
        "NZ"
    ],
    [
        "companyName",
        "Prezzee Limited"
    ],
    [
        "registration",
        "NZBN 9429049008357"
    ],
    [
        "supportEmail",
        "help@prezzee.com"
    ],
    [
        "corporateEmail",
        "corporate@prezzee.co.nz"
    ],
    [
        "phoneNumber",
        "+64 800 627 040"
    ],
    [
        "phoneNumberWithoutCountryCode",
        "0800 627 040"
    ],
    [
        "address",
        "Level 3, 9 Castlereagh Street, Sydney, NSW 2000"
    ],
    [
        "personalise",
        "personalise"
    ],
    [
        "Personalise",
        "Personalise"
    ],
    [
        "personalised",
        "personalised"
    ],
    [
        "incentivise",
        "incentivise"
    ],
    [
        "organisations",
        "organisations"
    ],
    [
        "energised",
        "energised"
    ],
    [
        "damn",
        "damn"
    ],
    [
        "customised",
        "customised"
    ],
    [
        "catalogue",
        "catalogue"
    ],
    [
        "apologise",
        "apologise"
    ],
    [
        "riskLink",
        "https://prezzeenz.zendesk.com/hc/en-us/requests/new?ticket_form_id=505267"
    ]
]);
function getLocalizedString(str) {
    var match = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    if (match.TAG !== /* Ok */ 0) {
        return _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(au, str);
    }
    switch(match._0){
        case /* GreatBritain */ 1:
            return _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(uk, str);
        case /* UnitedStates */ 2:
            return _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(us, str);
        case /* NewZealand */ 3:
            return _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(nz, str);
        case /* Australia */ 0:
        case /* Canada */ 4:
            return _rescript_std_lib_es6_belt_MapString_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2(au, str);
    }
}
var MapString;
 /* au Not a pure module */ 


/***/ }),

/***/ 74300:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CopyToClipboard = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _copyToClipboard = _interopRequireDefault(__webpack_require__(20640));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyToClipboard =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  function CopyToClipboard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CopyToClipboard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react["default"].Children.only(children);

      var result = (0, _copyToClipboard["default"])(text, options);

      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present


      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _text = _this$props2.text,
          _onCopy = _this$props2.onCopy,
          _options = _this$props2.options,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, ["text", "onCopy", "options", "children"]);

      var elem = _react["default"].Children.only(children);

      return _react["default"].cloneElement(elem, _objectSpread({}, props, {
        onClick: this.onClick
      }));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].PureComponent);

exports.CopyToClipboard = CopyToClipboard;

_defineProperty(CopyToClipboard, "defaultProps", {
  onCopy: undefined,
  options: undefined
});

/***/ }),

/***/ 74855:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(74300),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),

/***/ 11742:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3995,9774,2888,179], function() { return __webpack_exec__(75273); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);